import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { finalize } from 'rxjs'
import { LoadingService } from '../services/loading.service'

let totalRequests = 0
let completedRequests = 0

export const LoadingInterceptor: HttpInterceptorFn = (req, next) => {
    const loadingService = inject(LoadingService)

    loadingService.set(true)
    totalRequests++

    return next(req).pipe(
        finalize(() => {
            completedRequests++
            if (completedRequests === totalRequests) {
                loadingService.set(false)
                completedRequests = 0
                totalRequests = 0
            }
        })
    )
}
